import { PLANE_DEFAULT_Z } from '@Components/BigBrowse/BigBrowseConfig';
import type {
  PlaneSize,
  Position2D,
} from '@Components/BigBrowse/Model/ModelTypes';
import { RoundedRectangleMaskGeometry } from '@Components/BigBrowse/bb2/meshes2/primitives/RoundedRectangleMask';
import { VideoMaterial } from '@Components/BigBrowse/bb2/meshes2/primitives/VideoMaterial';
import React, { Suspense } from 'react';

type Props = {
  position: Position2D;
  size: PlaneSize;
  src: string;
  radius?: number;
  maskColor?: string;
  onLoad?: () => void;
  opacity?: number;
  sourceSize?: PlaneSize;
  zPosition?: number;
};
export function VideoPlane({
  position,
  size,
  src,
  radius = 0,
  maskColor = 'white',
  onLoad,
  opacity = 1,
  sourceSize,
  zPosition = PLANE_DEFAULT_Z,
}: Props) {
  return (
    <Suspense>
      <mesh position={[position.x, position.y, zPosition]}>
        <planeGeometry args={[size.width, size.height]} />
        <VideoMaterial
          src={src}
          containerSize={size}
          onLoad={onLoad}
          opacity={opacity}
          sourceSize={sourceSize}
        />
      </mesh>
      {/* For applying 'rounded' corners if needed, we overlay a 'hollow' mask on the video */}
      {radius > 0 && (
        <mesh position={[position.x, position.y, zPosition + 0.1]}>
          <RoundedRectangleMaskGeometry
            outer={size}
            inner={size}
            outerRadius={0}
            innerRadius={15}
          />
          <meshBasicMaterial color={maskColor} />
        </mesh>
      )}
    </Suspense>
  );
}
